/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";

export const TextAreaViewer = (props) => {
	const { Value } = props;
	
	return Value != null ? <span className="pndlm-line-break">{Value}</span> : "";
};
